export default "__VITE_ASSET__BRhnxGRJ__"